'use client';

import { GoogleAnalyticsScript, TealiumScript } from '@ctct/rise-scripts';
import { type ReactNode } from 'react';

import { SummitI18nNextIntlBridge } from '../components/SummitI18nNextIntlBridge';
import { BranchProvider, LazyMotionProvider, QueryClientProvider } from '../providers';

const PublicProviders = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <GoogleAnalyticsScript />
      <TealiumScript shouldAllowAnonymousUsers />
      <QueryClientProvider>
        <BranchProvider>
          <LazyMotionProvider>
            <SummitI18nNextIntlBridge>{children}</SummitI18nNextIntlBridge>
          </LazyMotionProvider>
        </BranchProvider>
      </QueryClientProvider>
    </>
  );
};

export { PublicProviders };
